import { MobileConfig, OUNode, Site, User } from '../types';

export interface SiteGroupCategory {
  id: string;
  name: string;
  groups: { id: string; name: string; members: number }[];
}

const SITE_GROUPS_BY_NODE: Record<string, SiteGroupCategory[]> = {
  'ou-europe': [
    { id: 'engineering', name: 'Engineering', groups: [
      { id: 'eu-e1', name: 'Eng EU - Frontend', members: 18 },
      { id: 'eu-e2', name: 'Eng EU - Backend', members: 22 },
      { id: 'eu-e3', name: 'Eng EU - DevOps', members: 11 },
      { id: 'eu-e4', name: 'Eng EU - QA', members: 8 },
    ]},
    { id: 'learning', name: 'Learning-restricted access', groups: [
      { id: 'eu-l1', name: 'L&D Europe', members: 60 },
      { id: 'eu-l2', name: 'Compliance Training EU', members: 34 },
    ]},
    { id: 'onboarding', name: 'Onboarding Page Access Groups', groups: [
      { id: 'eu-o1', name: 'New hires EU', members: 41 },
      { id: 'eu-o2', name: 'Onboarding - France office', members: 15 },
      { id: 'eu-o3', name: 'Onboarding - UK office', members: 12 },
    ]},
    { id: 'projects', name: 'Projects', groups: [
      { id: 'eu-p1', name: 'Project Meridian', members: 9 },
      { id: 'eu-p2', name: 'Project Horizon EU', members: 14 },
    ]},
    { id: 'role', name: 'Role-Based Groups', groups: [
      { id: 'eu-r1', name: 'EU Managers', members: 28 },
      { id: 'eu-r2', name: 'EU Team Leads', members: 19 },
    ]},
    { id: 'security', name: 'Security Team', groups: [
      { id: 'eu-s1', name: 'EU Security Ops', members: 6 },
      { id: 'eu-s2', name: 'GDPR Compliance Team', members: 10 },
    ]},
  ],
  'ou-americas': [
    { id: 'engineering', name: 'Engineering', groups: [
      { id: 'am-e1', name: 'Eng Americas - Platform', members: 31 },
      { id: 'am-e2', name: 'Eng Americas - Mobile', members: 14 },
      { id: 'am-e3', name: 'Eng Americas - Infra', members: 9 },
    ]},
    { id: 'learning', name: 'Learning-restricted access', groups: [
      { id: 'am-l1', name: 'Sales Enablement Americas', members: 55 },
      { id: 'am-l2', name: 'L&D Americas', members: 40 },
    ]},
    { id: 'onboarding', name: 'Onboarding Page Access Groups', groups: [
      { id: 'am-o1', name: 'New hires Americas', members: 38 },
      { id: 'am-o2', name: 'Onboarding - NYC office', members: 20 },
    ]},
    { id: 'projects', name: 'Projects', groups: [
      { id: 'am-p1', name: 'Project Liberty', members: 7 },
      { id: 'am-p2', name: 'Project Americas Growth', members: 16 },
    ]},
    { id: 'role', name: 'Role-Based Groups', groups: [
      { id: 'am-r1', name: 'Americas Managers', members: 35 },
      { id: 'am-r2', name: 'Americas Directors', members: 12 },
    ]},
    { id: 'security', name: 'Security Team', groups: [
      { id: 'am-s1', name: 'Americas SecOps', members: 8 },
      { id: 'am-s2', name: 'SOC 2 Compliance', members: 5 },
    ]},
  ],
  'ou-apac': [
    { id: 'engineering', name: 'Engineering', groups: [
      { id: 'ap-e1', name: 'Eng APAC - Cloud', members: 17 },
      { id: 'ap-e2', name: 'Eng APAC - Support', members: 24 },
      { id: 'ap-e3', name: 'Eng APAC - Data', members: 13 },
    ]},
    { id: 'learning', name: 'Learning-restricted access', groups: [
      { id: 'ap-l1', name: 'L&D APAC', members: 48 },
      { id: 'ap-l2', name: 'Regional Compliance APAC', members: 22 },
    ]},
    { id: 'onboarding', name: 'Onboarding Page Access Groups', groups: [
      { id: 'ap-o1', name: 'New hires APAC', members: 29 },
      { id: 'ap-o2', name: 'Onboarding - Singapore hub', members: 18 },
    ]},
    { id: 'projects', name: 'Projects', groups: [
      { id: 'ap-p1', name: 'Project Pacific', members: 11 },
      { id: 'ap-p2', name: 'Project APAC Expansion', members: 8 },
    ]},
    { id: 'role', name: 'Role-Based Groups', groups: [
      { id: 'ap-r1', name: 'APAC Managers', members: 21 },
      { id: 'ap-r2', name: 'APAC Regional Leads', members: 14 },
    ]},
    { id: 'security', name: 'Security Team', groups: [
      { id: 'ap-s1', name: 'APAC Security', members: 5 },
      { id: 'ap-s2', name: 'Data Privacy APAC', members: 7 },
    ]},
  ],
  'loc-france': [
    { id: 'engineering', name: 'Engineering', groups: [
      { id: 'fr-e1', name: 'Eng Paris - Core', members: 15 },
      { id: 'fr-e2', name: 'Eng Paris - Connect', members: 10 },
    ]},
    { id: 'learning', name: 'Learning-restricted access', groups: [
      { id: 'fr-l1', name: 'Formation France', members: 38 },
      { id: 'fr-l2', name: 'Conformité France', members: 20 },
    ]},
    { id: 'onboarding', name: 'Onboarding Page Access Groups', groups: [
      { id: 'fr-o1', name: 'Nouveaux arrivants Paris', members: 22 },
      { id: 'fr-o2', name: 'Onboarding - Paris HQ', members: 16 },
    ]},
    { id: 'projects', name: 'Projects', groups: [
      { id: 'fr-p1', name: 'Projet Lumière', members: 6 },
      { id: 'fr-p2', name: 'Paris Innovation Lab', members: 9 },
    ]},
    { id: 'role', name: 'Role-Based Groups', groups: [
      { id: 'fr-r1', name: 'France Managers', members: 17 },
      { id: 'fr-r2', name: 'France ICs', members: 45 },
    ]},
    { id: 'security', name: 'Security Team', groups: [
      { id: 'fr-s1', name: 'France SecOps', members: 4 },
      { id: 'fr-s2', name: 'CNIL Compliance', members: 6 },
    ]},
  ],
  'loc-uk': [
    { id: 'engineering', name: 'Engineering', groups: [
      { id: 'uk-e1', name: 'Eng London - API', members: 13 },
      { id: 'uk-e2', name: 'Eng London - Frontend', members: 11 },
    ]},
    { id: 'learning', name: 'Learning-restricted access', groups: [
      { id: 'uk-l1', name: 'UK L&D', members: 30 },
      { id: 'uk-l2', name: 'FCA Compliance Training', members: 18 },
    ]},
    { id: 'onboarding', name: 'Onboarding Page Access Groups', groups: [
      { id: 'uk-o1', name: 'New joiners London', members: 19 },
      { id: 'uk-o2', name: 'UK Graduate Programme', members: 10 },
    ]},
    { id: 'projects', name: 'Projects', groups: [
      { id: 'uk-p1', name: 'Project Albion', members: 7 },
      { id: 'uk-p2', name: 'London Growth Initiative', members: 12 },
    ]},
    { id: 'role', name: 'Role-Based Groups', groups: [
      { id: 'uk-r1', name: 'UK Managers', members: 14 },
      { id: 'uk-r2', name: 'UK Senior ICs', members: 33 },
    ]},
    { id: 'security', name: 'Security Team', groups: [
      { id: 'uk-s1', name: 'UK SecOps', members: 5 },
      { id: 'uk-s2', name: 'ISO 27001 Team', members: 8 },
    ]},
  ],
  'loc-us': [
    { id: 'engineering', name: 'Engineering', groups: [
      { id: 'us-e1', name: 'Eng US - Platform', members: 27 },
      { id: 'us-e2', name: 'Eng US - AI', members: 16 },
      { id: 'us-e3', name: 'Eng US - Enterprise', members: 12 },
    ]},
    { id: 'learning', name: 'Learning-restricted access', groups: [
      { id: 'us-l1', name: 'US Sales Training', members: 62 },
      { id: 'us-l2', name: 'US L&D', members: 44 },
    ]},
    { id: 'onboarding', name: 'Onboarding Page Access Groups', groups: [
      { id: 'us-o1', name: 'New hires US', members: 35 },
      { id: 'us-o2', name: 'Onboarding - New York', members: 18 },
      { id: 'us-o3', name: 'Onboarding - West Coast', members: 14 },
    ]},
    { id: 'projects', name: 'Projects', groups: [
      { id: 'us-p1', name: 'Project Eagle', members: 10 },
      { id: 'us-p2', name: 'US Market Expansion', members: 19 },
    ]},
    { id: 'role', name: 'Role-Based Groups', groups: [
      { id: 'us-r1', name: 'US Managers', members: 41 },
      { id: 'us-r2', name: 'US VPs', members: 9 },
      { id: 'us-r3', name: 'US Engineering Leads', members: 15 },
    ]},
    { id: 'security', name: 'Security Team', groups: [
      { id: 'us-s1', name: 'US SecOps', members: 9 },
      { id: 'us-s2', name: 'FedRAMP Team', members: 6 },
    ]},
  ],
  'loc-japan': [
    { id: 'engineering', name: 'Engineering', groups: [
      { id: 'jp-e1', name: 'Eng Japan - Localisation', members: 10 },
      { id: 'jp-e2', name: 'Eng Japan - Support', members: 14 },
    ]},
    { id: 'learning', name: 'Learning-restricted access', groups: [
      { id: 'jp-l1', name: 'Japan L&D', members: 26 },
      { id: 'jp-l2', name: 'Japan Compliance', members: 15 },
    ]},
    { id: 'onboarding', name: 'Onboarding Page Access Groups', groups: [
      { id: 'jp-o1', name: 'New hires Tokyo', members: 17 },
      { id: 'jp-o2', name: 'Japan Graduate Intake', members: 9 },
    ]},
    { id: 'projects', name: 'Projects', groups: [
      { id: 'jp-p1', name: 'Project Fuji', members: 8 },
      { id: 'jp-p2', name: 'Japan Enterprise Growth', members: 11 },
    ]},
    { id: 'role', name: 'Role-Based Groups', groups: [
      { id: 'jp-r1', name: 'Japan Managers', members: 12 },
      { id: 'jp-r2', name: 'Japan Team Leads', members: 18 },
    ]},
    { id: 'security', name: 'Security Team', groups: [
      { id: 'jp-s1', name: 'Japan SecOps', members: 4 },
      { id: 'jp-s2', name: 'APPI Compliance', members: 6 },
    ]},
  ],
  'loc-sgp': [
    { id: 'engineering', name: 'Engineering', groups: [
      { id: 'sg-e1', name: 'Eng Singapore - Cloud', members: 13 },
      { id: 'sg-e2', name: 'Eng Singapore - Data', members: 9 },
    ]},
    { id: 'learning', name: 'Learning-restricted access', groups: [
      { id: 'sg-l1', name: 'APAC Training Hub', members: 52 },
      { id: 'sg-l2', name: 'Singapore Compliance', members: 17 },
    ]},
    { id: 'onboarding', name: 'Onboarding Page Access Groups', groups: [
      { id: 'sg-o1', name: 'New hires Singapore', members: 21 },
      { id: 'sg-o2', name: 'Regional Graduate Programme', members: 13 },
    ]},
    { id: 'projects', name: 'Projects', groups: [
      { id: 'sg-p1', name: 'Project Lion City', members: 7 },
      { id: 'sg-p2', name: 'ASEAN Expansion', members: 10 },
    ]},
    { id: 'role', name: 'Role-Based Groups', groups: [
      { id: 'sg-r1', name: 'Singapore Managers', members: 11 },
      { id: 'sg-r2', name: 'ASEAN Regional Leads', members: 8 },
    ]},
    { id: 'security', name: 'Security Team', groups: [
      { id: 'sg-s1', name: 'Singapore SecOps', members: 5 },
      { id: 'sg-s2', name: 'MAS Compliance Team', members: 7 },
    ]},
  ],
};

const FALLBACK_SITE_GROUPS: SiteGroupCategory[] = [
  { id: 'engineering', name: 'Engineering', groups: [
    { id: 'fb-e1', name: 'Engineering - General', members: 10 },
  ]},
  { id: 'learning', name: 'Learning-restricted access', groups: [
    { id: 'fb-l1', name: 'L&D - General', members: 20 },
  ]},
  { id: 'onboarding', name: 'Onboarding Page Access Groups', groups: [
    { id: 'fb-o1', name: 'New hires - General', members: 15 },
  ]},
  { id: 'projects', name: 'Projects', groups: [
    { id: 'fb-p1', name: 'General Projects', members: 8 },
  ]},
  { id: 'role', name: 'Role-Based Groups', groups: [
    { id: 'fb-r1', name: 'All Managers', members: 25 },
  ]},
  { id: 'security', name: 'Security Team', groups: [
    { id: 'fb-s1', name: 'Security - General', members: 5 },
  ]},
];

export function getSiteGroupCategories(nodeId: string): SiteGroupCategory[] {
  return SITE_GROUPS_BY_NODE[nodeId] ?? FALLBACK_SITE_GROUPS;
}

const SITE_GROUPS_BY_SITE: Record<string, SiteGroupCategory[]> = {
  'site-par': [
    { id: 'editorial', name: 'Editorial', groups: [
      { id: 'sp-ed1', name: 'Paris News Editors', members: 8 },
      { id: 'sp-ed2', name: 'French Content Team', members: 14 },
    ]},
    { id: 'access', name: 'Access control', groups: [
      { id: 'sp-ac1', name: 'Paris All Staff', members: 210 },
      { id: 'sp-ac2', name: 'Paris Management', members: 22 },
      { id: 'sp-ac3', name: 'Paris Restricted Areas', members: 9 },
    ]},
    { id: 'comms', name: 'Communications', groups: [
      { id: 'sp-co1', name: 'Paris Town Hall Viewers', members: 180 },
      { id: 'sp-co2', name: 'Paris HR Announcements', members: 210 },
    ]},
    { id: 'collab', name: 'Collaboration', groups: [
      { id: 'sp-cl1', name: 'Paris Project Rooms', members: 45 },
      { id: 'sp-cl2', name: 'Paris Innovation Circle', members: 18 },
    ]},
  ],
  'site-lon': [
    { id: 'editorial', name: 'Editorial', groups: [
      { id: 'sl-ed1', name: 'London News Editors', members: 6 },
      { id: 'sl-ed2', name: 'UK Content Reviewers', members: 11 },
    ]},
    { id: 'access', name: 'Access control', groups: [
      { id: 'sl-ac1', name: 'London All Staff', members: 145 },
      { id: 'sl-ac2', name: 'London Senior Leadership', members: 15 },
      { id: 'sl-ac3', name: 'London Compliance View', members: 30 },
    ]},
    { id: 'comms', name: 'Communications', groups: [
      { id: 'sl-co1', name: 'London Broadcast Subscribers', members: 130 },
      { id: 'sl-co2', name: 'UK Benefits Readers', members: 145 },
    ]},
    { id: 'collab', name: 'Collaboration', groups: [
      { id: 'sl-cl1', name: 'London Cross-Team Working Groups', members: 38 },
      { id: 'sl-cl2', name: 'London Hackathon 2026', members: 22 },
    ]},
  ],
  'site-nyc': [
    { id: 'editorial', name: 'Editorial', groups: [
      { id: 'sn-ed1', name: 'NYC Content Publishers', members: 10 },
      { id: 'sn-ed2', name: 'US Editorial Board', members: 7 },
    ]},
    { id: 'access', name: 'Access control', groups: [
      { id: 'sn-ac1', name: 'NYC All Staff', members: 320 },
      { id: 'sn-ac2', name: 'NYC Executives', members: 18 },
      { id: 'sn-ac3', name: 'NYC Restricted Ops', members: 12 },
    ]},
    { id: 'comms', name: 'Communications', groups: [
      { id: 'sn-co1', name: 'NYC All-Hands Viewers', members: 300 },
      { id: 'sn-co2', name: 'US Payroll & Benefits', members: 320 },
    ]},
    { id: 'collab', name: 'Collaboration', groups: [
      { id: 'sn-cl1', name: 'NYC Innovation Lab', members: 55 },
      { id: 'sn-cl2', name: 'East Coast Customer Roundtable', members: 24 },
    ]},
  ],
  'site-tok': [
    { id: 'editorial', name: 'Editorial', groups: [
      { id: 'st-ed1', name: 'Tokyo Content Editors', members: 5 },
      { id: 'st-ed2', name: 'Japan Localisation Review', members: 8 },
    ]},
    { id: 'access', name: 'Access control', groups: [
      { id: 'st-ac1', name: 'Tokyo All Staff', members: 98 },
      { id: 'st-ac2', name: 'Tokyo Management Layer', members: 14 },
    ]},
    { id: 'comms', name: 'Communications', groups: [
      { id: 'st-co1', name: 'Japan Town Hall', members: 90 },
      { id: 'st-co2', name: 'Tokyo HR Notices', members: 98 },
    ]},
    { id: 'collab', name: 'Collaboration', groups: [
      { id: 'st-cl1', name: 'Tokyo Product Sync', members: 31 },
      { id: 'st-cl2', name: 'APAC Knowledge Base Contributors', members: 19 },
    ]},
  ],
  'site-sgp': [
    { id: 'editorial', name: 'Editorial', groups: [
      { id: 'ss-ed1', name: 'Singapore Content Team', members: 7 },
      { id: 'ss-ed2', name: 'ASEAN News Editors', members: 9 },
    ]},
    { id: 'access', name: 'Access control', groups: [
      { id: 'ss-ac1', name: 'Singapore All Staff', members: 112 },
      { id: 'ss-ac2', name: 'Singapore Leadership', members: 11 },
      { id: 'ss-ac3', name: 'APAC Hub Access', members: 45 },
    ]},
    { id: 'comms', name: 'Communications', groups: [
      { id: 'ss-co1', name: 'Singapore All-Hands', members: 105 },
      { id: 'ss-co2', name: 'ASEAN Benefits & HR', members: 112 },
    ]},
    { id: 'collab', name: 'Collaboration', groups: [
      { id: 'ss-cl1', name: 'Singapore Innovation Forum', members: 28 },
      { id: 'ss-cl2', name: 'Regional Sales Enablement', members: 40 },
    ]},
  ],
};

const FALLBACK_SITE_GROUPS_BY_SITE: SiteGroupCategory[] = [
  { id: 'access', name: 'Access control', groups: [
    { id: 'fb2-ac1', name: 'All Staff', members: 50 },
  ]},
  { id: 'comms', name: 'Communications', groups: [
    { id: 'fb2-co1', name: 'All Announcements', members: 50 },
  ]},
];

export function getSiteGroupCategoriesBySite(siteId: string): SiteGroupCategory[] {
  return SITE_GROUPS_BY_SITE[siteId] ?? FALLBACK_SITE_GROUPS_BY_SITE;
}

export const MOCK_USERS: User[] = [
  { id: 'u-1',  firstName: 'Aaron',     lastName: 'Jacob',     email: 'aaron.jacob@lumapps.com',      status: 'active',   accountType: 'Google',    updatedAt: '2026-05-05' },
  { id: 'u-2',  firstName: 'Abby',      lastName: 'Pharis',    email: 'abby@lumapps.com',             status: 'active',   accountType: 'Google',    updatedAt: '2026-05-11' },
  { id: 'u-3',  firstName: 'Adam',      lastName: 'Dalidowski',email: 'adam.dalidowski@beekeeper.io', status: 'active',   accountType: 'LumApps',   updatedAt: '2026-05-13' },
  { id: 'u-4',  firstName: 'Adam',      lastName: 'Partyka',   email: 'adam.partyka@lumapps.com',     status: 'active',   accountType: 'Google',    updatedAt: '2026-05-12' },
  { id: 'u-5',  firstName: 'Adeline',   lastName: 'Coulibaly', email: 'adeline.c@lumapps.com',        status: 'inactive', accountType: 'Google',    updatedAt: '2025-11-03' },
  { id: 'u-6',  firstName: 'Ahmed',     lastName: 'Khalil',    email: 'ahmed.khalil@lumapps.com',     status: 'active',   accountType: 'Microsoft', updatedAt: '2026-04-22' },
  { id: 'u-7',  firstName: 'Alexandra', lastName: 'Moreau',    email: 'a.moreau@lumapps.com',         status: 'active',   accountType: 'Google',    updatedAt: '2026-05-01' },
  { id: 'u-8',  firstName: 'Baptiste',  lastName: 'Dupont',    email: 'b.dupont@lumapps.com',         status: 'inactive', accountType: 'Google',    updatedAt: '2025-08-14' },
  { id: 'u-9',  firstName: 'Camille',   lastName: 'Fontaine',  email: 'c.fontaine@lumapps.com',       status: 'active',   accountType: 'LumApps',   updatedAt: '2026-03-30' },
  { id: 'u-10', firstName: 'David',     lastName: 'Osei',      email: 'd.osei@lumapps.com',           status: 'active',   accountType: 'Google',    updatedAt: '2026-05-08' },
  { id: 'u-11', firstName: 'Elena',     lastName: 'Vasquez',   email: 'e.vasquez@lumapps.com',        status: 'inactive', accountType: 'Microsoft', updatedAt: '2024-12-19' },
  { id: 'u-12', firstName: 'Fatima',    lastName: 'Al-Rashid', email: 'f.alrashid@lumapps.com',       status: 'active',   accountType: 'Google',    updatedAt: '2026-04-17' },
  { id: 'u-13', firstName: 'Hiroshi',   lastName: 'Tanaka',    email: 'h.tanaka@lumapps.com',         status: 'active',   accountType: 'Google',    updatedAt: '2026-05-02' },
  { id: 'u-14', firstName: 'Ingrid',    lastName: 'Svensson',  email: 'i.svensson@lumapps.com',       status: 'inactive', accountType: 'Google',    updatedAt: '2025-06-28' },
  { id: 'u-15', firstName: 'James',     lastName: 'Okafor',    email: 'j.okafor@lumapps.com',         status: 'active',   accountType: 'LumApps',   updatedAt: '2026-05-14' },
];

export const INITIAL_MOBILE_CONFIGS: MobileConfig[] = [
  { id: 'mc-1', name: 'MC Europe' },
  { id: 'mc-2', name: 'MC APAC' },
  { id: 'mc-3', name: 'MC Americas' },
  { id: 'mc-4', name: 'MC Worldwide' },
  { id: 'mc-5', name: 'MC Middle East' },
];

export const INITIAL_NODES: OUNode[] = [
  // Top-level org units
  { id: 'ou-europe',   name: 'Europe',         type: 'OrganizationalUnit', parentId: null,          mobileConfigId: null, createdAt: '2025-01-10', updatedAt: '2026-01-10' },
  { id: 'ou-americas', name: 'Americas',       type: 'OrganizationalUnit', parentId: null,          mobileConfigId: null, createdAt: '2025-01-10', updatedAt: '2026-01-10' },
  { id: 'ou-apac',     name: 'APAC',           type: 'OrganizationalUnit', parentId: null,          mobileConfigId: null, createdAt: '2025-01-10', updatedAt: '2026-01-10' },
  // Europe locations
  { id: 'loc-france',  name: 'France',         type: 'Location',           parentId: 'ou-europe',   mobileConfigId: null, createdAt: '2025-01-15', updatedAt: '2026-02-01' },
  { id: 'loc-uk',      name: 'United Kingdom', type: 'Location',           parentId: 'ou-europe',   mobileConfigId: null, createdAt: '2025-01-15', updatedAt: '2026-02-01' },
  // Americas locations
  { id: 'loc-us',      name: 'United States',  type: 'Location',           parentId: 'ou-americas', mobileConfigId: null, createdAt: '2025-01-15', updatedAt: '2026-02-01' },
  // APAC locations
  { id: 'loc-japan',   name: 'Japan',          type: 'Location',           parentId: 'ou-apac',     mobileConfigId: null, createdAt: '2025-01-15', updatedAt: '2026-02-01' },
  { id: 'loc-sgp',     name: 'Singapore',      type: 'Location',           parentId: 'ou-apac',     mobileConfigId: null, createdAt: '2025-01-15', updatedAt: '2026-02-01' },
];

// 5 sites total — none mapped yet (admin assigns in Site mapping)
export const INITIAL_SITES: Site[] = [
  { id: 'site-par',  name: 'LumApps Paris',     assignedNodeId: null, createdAt: '2025-06-01', updatedAt: '2026-03-15' },
  { id: 'site-lon',  name: 'LumApps London',    assignedNodeId: null, createdAt: '2025-06-15', updatedAt: '2026-01-20' },
  { id: 'site-nyc',  name: 'LumApps New York',  assignedNodeId: null, createdAt: '2024-06-01', updatedAt: '2025-03-10' },
  { id: 'site-tok',  name: 'LumApps Tokyo',     assignedNodeId: null, createdAt: '2024-09-15', updatedAt: '2025-02-10' },
  { id: 'site-sgp',  name: 'LumApps Singapore', assignedNodeId: null, createdAt: '2025-07-01', updatedAt: '2026-02-10' },
];
